import React, { useState, useEffect } from 'react'; 
import './Schools.css';

export const Schools = ({ onSchoolSelect }) => {
  const [input, setInput] = useState("");
  const [filteredSchools, setFilteredSchools] = useState([]);
  const [allSchools, setAllSchools] = useState([]);  // To store the fetched schools

  // Fetch schools data from the JSON file
  const fetchData = async () => {
    try {
      const response = await fetch("./universities.json");  // Adjust path if needed
      const data = await response.json();
      setAllSchools(data);  // Save fetched data to allSchools
    } catch (error) {
      console.error("Error fetching school data:", error);
    }
  };

  // Filter the schools based on the search input (name or abbreviation)
  const filterSchools = (value) => {
    const filtered = allSchools.filter((school) =>
      school.name.toLowerCase().includes(value.toLowerCase()) || 
      school.abbreviation.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSchools(filtered);
  };

  // Handle input change
  const handleChange = (e) => {
    const value = e.target.value;
    setInput(value);
    filterSchools(value);  // Filter the schools as the user types
  };

  // Handle click on a school result
  const handleSchoolClick = (school) => {
    setInput(school.name); // Update search input to the selected school
    onSchoolSelect(school); // Trigger the onSchoolSelect callback to pass the selected school to the parent component
    setFilteredSchools([]); // Clear the filtered schools (this hides the dropdown)
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchData();  // Call fetchData on initial render
  }, []);

  return (
    <div className="input-wrapper">
      <input
        placeholder="Search for a school"
        value={input}
        onChange={handleChange}
        className="search-input"
      />
      
      {/* Display search results only if input is not empty, hasn't been selected, and filteredSchools is not empty */}
      {input && filteredSchools.length > 0 && 
        filteredSchools.map((school, index) => (
          <div 
            key={index} 
            className="school-item" 
            onClick={() => handleSchoolClick(school)}
          >
            <span className="school-name">{school.name}</span>
          </div>
        ))
      }
    </div>
  );
};
